module.exports = __webpack_public_path__ + "static/media/enchanting-color-pallete.db9f889d.png";